"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecognizeCharacterPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const recognize_character_1 = require("../../network/recognize-character");
const material_1 = require("@mui/material");
const use_lazy_promise_1 = require("../../hook/use-lazy-promise");
const fetch_result_renderer_1 = require("../../component/fetch-result-renderer");
const button_1 = require("../../component/input/button");
const passage_meta_1 = require("../../model/passage-meta");
const passage_details_1 = require("../../network/passage-details");
const word_card_1 = require("./word-card");
const word_details_1 = require("./word-details");
const log_view_layout_1 = require("../../component/log-view-layout");
const log_1 = require("../../model/log");
exports.RecognizeCharacterPage = (0, react_1.memo)(() => {
    const { id } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const theme = (0, material_1.useTheme)();
    const [selectedWord, setSelectedWord] = (0, react_1.useState)(null);
    const { status: updateStatus, execute: executeUpdate } = (0, use_lazy_promise_1.useLazyPromise)(passage_details_1.updateWordStatus);
    const { result, status, error, execute } = (0, use_lazy_promise_1.useLazyPromise)(recognize_character_1.getPassageWords);
    (0, react_1.useEffect)(() => {
        if (id) {
            execute(id);
        }
    }, [execute, id]);
    (0, react_1.useEffect)(() => {
        if (result &&
            result.length > 0 &&
            result.findIndex((u) => u === selectedWord) === -1) {
            setSelectedWord(result[0]);
        }
    }, [result, selectedWord]);
    const handleComplete = (0, react_1.useCallback)(() => {
        if (!id) {
            return;
        }
        executeUpdate(id, passage_meta_1.PassageTaskStatus.COMPLETED);
    }, [executeUpdate, id]);
    (0, react_1.useEffect)(() => {
        if (updateStatus === use_lazy_promise_1.FetchStatus.Success) {
            navigate(`/detail/${id}?mode=${passage_meta_1.PassageLearningMode.LISTEN}`);
        }
    }, [updateStatus, id, navigate]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", spacing: 4, alignItems: "center", padding: 8, children: [(0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.RecognizeCharacterPage }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", children: "\u672C\u6587\u65B0\u5B57" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { children: "Please click each character below to learn" }), (0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: result, status: status, errorMessages: error === null || error === void 0 ? void 0 : error.message, sx: {
                    flex: 1,
                }, children: (data) => ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", spacing: 4, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "row", width: "100%", overflow: "auto", spacing: 2, justifyContent: "center", children: data.map((word, index) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [index > 0 && (0, jsx_runtime_1.jsx)(material_1.Divider, { orientation: "vertical", variant: "middle", flexItem: true }), (0, jsx_runtime_1.jsx)(word_card_1.WordCard, { word: word, selected: selectedWord === word, onClick: () => {
                                            setSelectedWord(word);
                                        } }, word.word)] }))) }), selectedWord && (0, jsx_runtime_1.jsx)(word_details_1.WordDetails, { word: selectedWord }), (0, jsx_runtime_1.jsx)(button_1.Button, { size: "large", variant: "contained", onClick: handleComplete, startIcon: updateStatus === use_lazy_promise_1.FetchStatus.Loading ? ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { sx: { width: theme.spacing(2), height: theme.spacing(2) }, size: "small", color: "secondary" })) : null, disabled: updateStatus === use_lazy_promise_1.FetchStatus.Loading, children: "Done! Let's listen!" })] })) })] }));
});
exports.RecognizeCharacterPage.displayName = "RecognizeCharacterPage";
exports.default = exports.RecognizeCharacterPage;
